import {useDispatch, useSelector} from "react-redux";
import {docViewer, hideDocViewer, openDocViewer, openLicenseViewer} from "../store/slice";
import {useState} from "react";
import {
    UseManageWorkspacesAndOrganizations
} from "../../../../newDomain/authWorkspacesCookies/workspaces/hooks/useManageWorkspacesAndOrganizations";

export const usePDFView = () => {

    const dispatch = useDispatch();

    const handleClose = () => {dispatch(hideDocViewer())};
    const handleOpen = (payload: {fileId: string, fileName: string}) => {dispatch(openDocViewer(payload))};
    const handleOpenLicenseView = () => {dispatch(openLicenseViewer())};

    const workspaceId = UseManageWorkspacesAndOrganizations().workspaceId || '';

    const [file, setFile] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [numPages, setNumPages] = useState<number | null>(null);
    const [pageNumber, setPageNumber] = useState<number>(1);

    return {
        handleClose,
        handleOpen,
        handleOpenLicenseView,

        file, setFile,
        isLoading, setIsLoading,
        numPages, setNumPages,
        pageNumber, setPageNumber,

        workspaceId,
        PDFDialog: useSelector(docViewer)
    }
}